import React, { ReactNode } from 'react';
import { Link, ButtonLink as TonicButtonLink, Space, Icon } from '@tonic-ui/react';

interface ExternalLinkProps extends StyledSystemProps {
  children?: ReactNode;
  href?: string;
  showIcon?: boolean;
  className?: string;
  style?: StyledSystemProps;
  alt?: string;
}

const defaultProps: Partial<ExternalLinkProps> = {
  showIcon: true,
};

const ExternalLink = React.forwardRef<HTMLLinkElement, ExternalLinkProps>(
  (props, ref): JSX.Element => (
    <Link
      ref={ref}
      target="_blank"
      rel="noopener noreferrer"
      textDecoration={props?.textDecoration || 'underline'}
      {...props}
    >
      {props.children}
      {props.showIcon && (
        <>
          <Space width="2x" />
          <Icon icon="external-link" />
        </>
      )}
    </Link>
  )
);

// for passing default props to the component with forwardRef
ExternalLink.defaultProps = defaultProps;
ExternalLink.displayName = 'ExternalLink';

interface ExternalButtonLinkProps extends StyledSystemProps {
  children?: ReactNode;
  href: string;
}

export const ExternalButtonLink = React.forwardRef<HTMLLinkElement, ExternalButtonLinkProps>(
  (props, ref): JSX.Element => (
    <TonicButtonLink
      ref={ref}
      target="_blank"
      rel="noopener noreferrer"
      textDecoration="none"
      {...props}
    />
  )
);

// for passing default props to the component with forwardRef
ExternalButtonLink.displayName = 'ExternalButtonLink';

export default ExternalLink;
